import React from 'react';
import clsx from 'clsx';

import { Button as StyledButton } from './wrappers';

export interface IButton extends React.ComponentPropsWithRef<typeof StyledButton> {
  size?: 'small' | 'large';
  tone?:
    | false
    | 'forward'
    | 'positive'
    | 'neutral'
    | 'soft'
    | 'warning'
    | 'ghost'
    | 'transparent'
    | 'inverted';
  rounded?: boolean;
  circle?: boolean;
  full?: boolean;
  large?: boolean;
  wide?: boolean;
  href?: string;
  as?: React.ElementType;
  target?: string;
}

const Button = (props: IButton) => {
  const { circle, size, tone, rounded, full, wide, large } = props;

  const className = clsx(
    props.className,
    size && `size-${size}`,
    tone && `tone-${tone}`,
    rounded && 'rounded',
    circle && 'circle',
    full && 'full',
    wide && 'wide',
    large && 'large',
  );

  return <StyledButton {...props} className={className} />;
};

export default Button;
